// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/list_vision_locations.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionLocation } from "./vision_location_pb";
import { file_vision_projects_v1_vision_location } from "./vision_location_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/list_vision_locations.proto.
 */
export const file_vision_projects_v1_list_vision_locations: GenFile = /*@__PURE__*/
  fileDesc("Ci52aXNpb24vcHJvamVjdHMvdjEvbGlzdF92aXNpb25fbG9jYXRpb25zLnByb3RvEhlwcm90b3MudmlzaW9uLnByb2plY3RzLnYxIogBChpMaXN0VmlzaW9uTG9jYXRpb25zUmVxdWVzdBJMCgZwYXJhbXMYASABKAsyPC5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLkxpc3RWaXNpb25Mb2NhdGlvbnNSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSKwAQobTGlzdFZpc2lvbkxvY2F0aW9uc1Jlc3BvbnNlEk0KBnJlc3VsdBgBIAEoCzI9LnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuTGlzdFZpc2lvbkxvY2F0aW9uc1Jlc3BvbnNlLlJlc3VsdBpCCgZSZXN1bHQSOAoFaXRlbXMYASADKAsyKS5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLlZpc2lvbkxvY2F0aW9uYgZwcm90bzM", [file_vision_projects_v1_vision_location]);

/**
 * @generated from message protos.vision.projects.v1.ListVisionLocationsRequest
 */
export type ListVisionLocationsRequest = Message<"protos.vision.projects.v1.ListVisionLocationsRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.ListVisionLocationsRequest.Params params = 1;
   */
  params?: ListVisionLocationsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.ListVisionLocationsRequest.
 * Use `create(ListVisionLocationsRequestSchema)` to create a new message.
 */
export const ListVisionLocationsRequestSchema: GenMessage<ListVisionLocationsRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_vision_locations, 0);

/**
 * @generated from message protos.vision.projects.v1.ListVisionLocationsRequest.Params
 */
export type ListVisionLocationsRequest_Params = Message<"protos.vision.projects.v1.ListVisionLocationsRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.projects.v1.ListVisionLocationsRequest.Params.
 * Use `create(ListVisionLocationsRequest_ParamsSchema)` to create a new message.
 */
export const ListVisionLocationsRequest_ParamsSchema: GenMessage<ListVisionLocationsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_vision_locations, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.ListVisionLocationsResponse
 */
export type ListVisionLocationsResponse = Message<"protos.vision.projects.v1.ListVisionLocationsResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.ListVisionLocationsResponse.Result result = 1;
   */
  result?: ListVisionLocationsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.ListVisionLocationsResponse.
 * Use `create(ListVisionLocationsResponseSchema)` to create a new message.
 */
export const ListVisionLocationsResponseSchema: GenMessage<ListVisionLocationsResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_vision_locations, 1);

/**
 * @generated from message protos.vision.projects.v1.ListVisionLocationsResponse.Result
 */
export type ListVisionLocationsResponse_Result = Message<"protos.vision.projects.v1.ListVisionLocationsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.projects.v1.VisionLocation items = 1;
   */
  items: VisionLocation[];
};

/**
 * Describes the message protos.vision.projects.v1.ListVisionLocationsResponse.Result.
 * Use `create(ListVisionLocationsResponse_ResultSchema)` to create a new message.
 */
export const ListVisionLocationsResponse_ResultSchema: GenMessage<ListVisionLocationsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_vision_locations, 1, 0);

